module.exports = __webpack_public_path__ + "media/images/pc/top/recommend-plan-text-maedori4-d536921f76684d81162309de16fe046d.png";